'use client'

export const buildLocalHost = () => {
  if (typeof window !== 'undefined') {
    return window ? window.location.protocol + '//' + window.location.host : ''
  } else {
    return null
  }
}
